// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { compose } from 'recompose';
import { withHandlers } from 'recompose';
import constants from 'logic/data/Izenda.ReportDesignerConstants';
import { curry } from 'lodash/fp';
import { ALERT_TYPES, SHOW_TYPES } from 'logic/data/Izenda.AlertConstants';
import typeof AlertDetails from 'logic/models/Izenda.AlertDetails';

const actions = compose(
  withHandlers({
    disableReport: curry(disableReport),
    detectReportChange: curry(detectReportChange),
    handleCascadingChanged: curry(handleCascadingChanged),
    handleNeedUpdateResultChanged: curry(handleNeedUpdateResultChanged)
  })
);

/**
 * Handle cascading change
 * @param {Object} props
 * @param {boolean} change
 */
function handleCascadingChanged(props: any, change: boolean): void {
  change &&
    props.confirmFn('Information', {
      type: 'info',
      description: constants.CASCADING_CHANGED_MESSAGE,
      showCloseIndicator: true
    });
}

/**
 * Handle need update result changed
 * @param {Object} props
 * @param {boolean} change
 * @param {AlertDetails} alertDetails
 */
function handleNeedUpdateResultChanged(props: {}, change: boolean, alertDetails: AlertDetails) {
  const { localization } = props;

  if (change) {
    alertDetails.set({
      message: localization.getText('REPORTDESIGNER_UPDATE_RESULT'),
      type: ALERT_TYPES.INFO,
      success: true,
      showType: SHOW_TYPES.ALWAYS
    });
  } else {
    alertDetails.reset();
  }
}

/**
 * Disable report action in case of report being invalid
 */
function disableReport(props: {}, _) {
  props.store.disable();
  return false;
}

/**
 * Detect report change
 * @return {Promise} { boolean }
 */
function detectReportChange(props: {}, store, pageName: string) {
  // var store = this.masterStore;

  return store.detectReportChange(pageName).then((result: {}) => {
    if (result.success) {
      return Promise.resolve(true);
    }

    const error = result.messages[0];
    switch (error.key) {
      case constants.DETECT_CHANGE.PHYSICAL:
        return props
          .confirmFn('Information', {
            description: error.messages[0],
            type: 'info',
            showCloseIndicator: true
          })
          .then(disableReport.bind(null, props));
      case constants.DETECT_CHANGE.LOGICAL:
        return props.confirmFn('Confirmation', {
          description: error.messages[0]
        });
    }
    return Promise.resolve(false);
  });
}

export default actions;



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.ReportViewerActions.js